import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import { convertMsToMph } from "../utils/conversions";

const EventItem = ({ event, onDelete, color }) => {
  var CarryInYards = Number.parseFloat(event.data.Carry * 1.0936).toFixed(2);
  const hasNullOrUndefinedValues = Object.values(event.data).some((it) => it === (null || undefined));
  const isMissingValues = Object.keys(event.data).length < 22;
  
  return (
    <ListItem
      sx={{ 
        backgroundColor: hasNullOrUndefinedValues || isMissingValues ? "red" : color,
        padding: '12px 16px'
      }}
    >
      <ListItemText 
        primary={"Swing " + (event.key + 1)} 
        sx={{ minWidth: '120px', maxWidth: '120px' }} 
      />
      <Box sx={{ display: 'flex', gap: 3, flex: 1, alignItems: 'center' }}>
        <ListItemText 
          primary={"Carry: " + CarryInYards + " yds"} 
          sx={{ minWidth: '140px', textAlign: 'center' }}
          primaryTypographyProps={{ style: { textAlign: 'center' } }}
        />
        <ListItemText 
          primary={"Launch: " + (event.data.LaunchAngle ? event.data.LaunchAngle.toFixed(1) + "°" : "N/A")} 
          sx={{ minWidth: '120px', textAlign: 'center' }}
          primaryTypographyProps={{ style: { textAlign: 'center' } }}
        />
        <ListItemText 
          primary={"Ball Speed: " + (event.data.BallSpeed ? convertMsToMph(event.data.BallSpeed).toFixed(1) + " mph" : "N/A")} 
          sx={{ minWidth: '150px', textAlign: 'center' }}
          primaryTypographyProps={{ style: { textAlign: 'center' } }}
        />
        <ListItemText 
          primary={"Spin Rate: " + (event.data.SpinRate ? Math.round(event.data.SpinRate) + " rpm" : "N/A")} 
          sx={{ minWidth: '150px', textAlign: 'center' }}
          primaryTypographyProps={{ style: { textAlign: 'center' } }}
        />
      </Box>
      <IconButton onClick={() => onDelete(event.key)} sx={{ minWidth: '48px' }}>
        <DeleteIcon />
      </IconButton>
    </ListItem>
  );
};

export default EventItem;
